<template>
  <AlertDialog :open="updateAvailable">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Update Available</AlertDialogTitle>
        <AlertDialogDescription>
          A new version of the application has been deployed. Please reload to get the latest
          updates.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction @click="reload"> Reload </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<script setup>
import { useVersionCheck } from '@/composables/useVersionCheck';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

const { updateAvailable } = useVersionCheck();

function reload() {
  const url = new URL(window.location.href);
  url.searchParams.set('_v', Date.now().toString());
  window.location.replace(url.toString());
}
</script>
